<template>
  <li class="list-item">
    <component
      :is="tag || BaseLink"
      v-for="index in 2"
      :key="index"
      :link="item"
      class="item"
      v-bind="{
        ...$attrs,
        ...(index === 2 && {
          class: `item--inverted`,
          'aria-hidden': true,
          tabIndex: -1
        })
      }"
    >
      <span v-if="$slots.prefix" class="item__prefix t-faq4">
        <slot name="prefix" />
      </span>

      <span class="item__label t-faq2" v-html="nbsp(item.label)" />

      <div class="item__icon">
        <slot name="icon" />
      </div>

      <slot name="after" />
    </component>
  </li>
</template>

<script lang="ts" setup>
const BaseLink = resolveComponent('BaseLink')

defineProps<{
  tag?: keyof HTMLElementTagNameMap | Component
  item: { label: string }
}>()
</script>

<style lang="scss" scoped>
.list-item {
  position: relative;
  border-top: rem(1px) solid $line;

  &:last-child {
    border-bottom: rem(1px) solid $line;
  }

  .contrast-mode & {
    border-color: $contrast-black;
  }
}

.item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding: rem(28px) rem(9px);
  text-align: left;

  @include media-up(md) {
    padding: rem(31px) rem(36px);
  }

  @include media-up(lg) {
    padding: rem(40px) rem(50px);
  }

  &__prefix {
    margin-right: rem(10px);
    text-transform: uppercase;
  }

  &__label {
    width: 75%;

    @include media-up(md) {
      width: 85%;
    }
  }

  &__icon {
    @include size(rem(18px));
    @include center-content;
    flex-shrink: 0;
    margin-left: auto;
    transition: transform $transition-slow;

    .list-item:hover & {
      transform: translateX(-100%) rotate(-360deg);
    }
  }

  &--inverted {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    clip-path: inset(100% 0 0 0);
    color: $beige;
    pointer-events: none;
    background: $dark-brown;
    transition: clip-path $transition-slow;

    .list-item:hover & {
      clip-path: inset(0 0 0 0);
    }

    &::before {
      @include fill-space;
      z-index: -1;
      content: '';
      background: $dark-brown;
    }
  }
}
</style>
